// language=GraphQL
export const ALL_ONLINE_PAYMENT_CONFIGS_QUERY = `query Query {
  onlinePaymentConfigs: tenantOnlinePaymentConfigs {
    id
    enabled
    datatransMerchantId
    datatransMerchantPw
    ratioFibuAccountNo
    infoText
    datatransThemeConfig
  }
}`

// language=GraphQL
export const SINGLE_ONLINE_PAYMENT_CONFIG_QUERY = `query Query($id: ID!) {
  onlinePaymentConfig: tenantOnlinePaymentConfig(id: $id) {
    id
    enabled
    datatransMerchantId
    datatransMerchantPw
    ratioFibuAccountNo
    infoText
    datatransThemeConfig
  }
}`

// language=GraphQL
export const CREATE_ONLINE_PAYMENT_CONFIG_MUTATION = `
  mutation Mutation($input: CreateTenantOnlinePaymentConfigInput) {
    onlinePaymentConfig: createTenantOnlinePaymentConfig(input: $input) {
      id
      enabled
      datatransMerchantId
      datatransMerchantPw
      ratioFibuAccountNo
      infoText
      datatransThemeConfig
    }
  }`

// language=GraphQL
export const UPDATE_ONLINE_PAYMENT_CONFIG_MUTATION = `
  mutation Mutation($input: UpdateTenantOnlinePaymentConfigInput) {
    onlinePaymentConfig: updateTenantOnlinePaymentConfig(input: $input) {
      id
      enabled
      datatransMerchantId
      datatransMerchantPw
      ratioFibuAccountNo
      infoText
      datatransThemeConfig
    }
  }`

// language=GraphQL
export const DELETE_ONLINE_PAYMENT_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteTenantOnlinePaymentConfigInput) {
    deleteTenantOnlinePaymentConfig(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_ONLINE_PAYMENT_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteTenantOnlinePaymentConfigInput) {
    forceDeleteTenantOnlinePaymentConfig(input: $input) {
      success
    }
  }`
// language=GraphQL
export const ONLINE_PAYMENT_CONFIGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTenants: Boolean = false) {
  groupedDependents: tenantOnlinePaymentConfigDependents(id: $id) {
    tenants @include(if: $withTenants) {
      id
      name
      slug
      domain
      externalReference
    }
  }
}`
